export const AVAILABILITIES_URL = 'api/1/platforms/restaurants/availabilities';
export const AVAILABILITIES_CONFIG_URL = 'api/1/platforms/config/availabilities';
